export const MENU_BTN_CLICK = 'menuBtnClickMenu';
export const MENU_RESIZE = 'menuResizeMenu';
